// Warm only the category the customer is currently exploring. The destination's
// head and menu use the same responsive source, so navigation can reuse the image.
const warmed = new Set();
function warmCategory(event) {
  if (navigator.connection?.saveData) return;
  const item = event.target.closest?.('[data-fk-preload-collection]');
  const source = item?.querySelector('template[data-fk-destination-image]')?.content.querySelector('link');
  if (!source || warmed.has(source.href)) return;
  warmed.add(source.href);
  document.head.append(source.cloneNode(true));
}
document.addEventListener('pointerover', warmCategory, { passive: true });
document.addEventListener('focusin', warmCategory);
